module.exports = __webpack_public_path__ + "a9013fef4036889feed0744686e78d5e.pdf";